import React from "react";
import { createUseStyles } from "react-jss";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const useStyles = createUseStyles(theme => ({
  link: {
    color: theme.textColor,
    cursor: "pointer",
    display: "flex",
    "align-items": "center",
    "&:hover": {
      opacity: 0.8,
      "& span": {
        display: "initial !important",
      },
    },
  },
  icon: {
    color: props => (props.active ? theme.colorRed : theme.textColor),
    "font-size": theme.iconSize,
    "margin-right": theme.spacing2,
  },
  name: {},
  active: {},
  "@media (max-width: 580px)": {
    name: {
      display: "none",
    },
    active: {
      display: "initial !important",
    },
  },
}));

const ButtonLink = ({ className, name, active, onClick, icon }) => {
  const classes = useStyles({ active });
  return (
    <div className={clsx(classes.link, className)} onClick={onClick}>
      {icon && <FontAwesomeIcon className={classes.icon} icon={icon} />}
      <span className={clsx(classes.name, { [classes.active]: active })}>
        {name}
      </span>
    </div>
  );
};

export default ButtonLink;
